<template>
    <form @submit.prevent="submit" class="code-return">
        <div class="row">
            <div class="col-12">
                <h3 class="text-center"> Recupere seu acesso </h3>
            </div>
            <div class="col-12 mt-3 mb-3 text-justify">
                Enviamos um email para <strong>{{stripEmail(access.email)}}</strong> contendo um código de acesso, insira o código abaixo para recuperar o acesso
                à sua conta. Caso o e-mail não chegue em alguns minutos, clique aqui para <a>reenviar</a>, se o problema persistir entre em contato com o suporte. 
            </div>
        </div>
        <div class="code-form mt-3 mb-3 row">
            <div class="col-md-12">
                <input
                    class="form-control"
                    v-model="code"
                    type="text"
                    name="access-code"
                    v-validate="'required'"
                    placeholder="Código de acesso"
                    data-vv-as="código de acesso" 
                />
                <div class="invalid-feedback">
                    @{{ errors.first('código de acesso') }}
                </div>
            </div>
            <div class="col-md-12 mt-2">
                <button v-if="!loading" class="form-control btn-success btn-lg" type="submit"> VALIDAR </button>
                <button v-else class="form-control btn-success btn-lg d-flex justify-content-center align-items-center" type="button" disabled>
                    <div class="spinner-border text-dark" role="status"></div>
                </button>
            </div>
        </div>
    </form>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    data() {
        return {
            code: '',
            loading: false,
        }
    },
    props: {
        access: {
            required: true
        }
    },
    methods: {
        async submit() {
            try {
                this.loading = true
                
                const response = await axios.post(`/account/recover/verify`, {
                    token: this.access.token,
                    document: this.access.document,
                    code: this.code
                })
                
                this.$emit('success', response.data)
            } catch (error) {
                this.$emit('error', error.response.data.message)
            } finally {
                this.loading = false
            }
        },
        stripEmail(email) {
            return email.split(' ')[0]
        }
    }
})
</script>

<style scoped>
    .np {
        padding: 0px !important;
    }

    .nm {
        margin: 0px !important;
    }

    .form-control {
        font-size: 16px;
    }
    
    .text-justify {
        text-align: justify;
    }
</style>